import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Radio } from '@rebass/forms/styled-components';
import { Checkbox } from '@getro/rombo';

export const CheckBoxItem = ({ selected, onRemove, onAdd, type, option, variant, children }) => {
  const toggle = () => (selected ? onRemove() : onAdd());

  return (
    <Flex
      tx="forms"
      variant={selected ? `${variant}InputContainerAccent` : `${variant}InputContainer`}
      sx={{
        cursor: 'pointer',
        borderRadius: '4px',
        gap: '16px',
      }}
      padding="8px 16px"
      onClick={toggle}
      data-testid={`${type}${`-${option.id}`}`}
    >
      <Box sx={{ position: 'relative' }} mt="4px">
        <Box width="100%" height="100%" sx={{ position: 'absolute' }} />
        {type === 'checkbox' ? (
          <Checkbox
            variant={`${variant}Checkbox`}
            onChange={toggle}
            name={option.label}
            checked={selected}
            value={selected}
          />
        ) : (
          <Radio
            variant={`${variant}Radio`}
            onChange={toggle}
            name={option.label}
            checked={selected}
            value={selected}
          />
        )}
      </Box>
      <Box width="100%">
        <Text lineHeight="24px" as="h3" color="text.dark" fontWeight="500" fontSize="16px">
          {option.label || option.name}
        </Text>
        <Text fontSize="14px" lineHeight="24px" color="text.main">
          {option.description}
        </Text>
        {children}
      </Box>
    </Flex>
  );
};
CheckBoxItem.defaultProps = {
  children: null,
  variant: 'default',
};

CheckBoxItem.propTypes = {
  children: PropTypes.node,
  onRemove: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['radio', 'checkbox']).isRequired,
  option: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    description: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  variant: PropTypes.string,
};
